<template>
  <div v-if="basicHsbList && apparatusDetails">
    <b-row align-h="center" class="mb-0 pb-0 current-plan" no-gutters>
      <b-col>
        <div align-h="around" class="row mb-3 ml-3 mr-3">
          <p class="text-center plan-details-header" data-test-hook="new-plan-with-upgrade-text">
            {{ $t('xFuelMonitorRequiresPremiumWithHsb') }}
          </p>
        </div>
      </b-col>
    </b-row>
    <SubscriptionCard
      :subscription-product="selectedProduct"
      :existing-apparatuses="[]"
      :apparatuses-to-add="[apparatusDetails, ...basicHsbList]"
      :is-new-plan="true"
      :monthly-paid-product="monthlyPaidProduct"
      :annual-paid-product="annualPaidProduct"
      :hide-badge="true"
      @setSelectedProduct="setSelectedProduct"
    />
    <b-row no-gutters class="mt-3">
      <b-col cols="12" class="float-left">
        <b-button
          variant="warning"
          class="w-100"
          :disabled="isCreatingPurchaseIntent"
          @click="$emit('openPayment')"
          data-test-hook="subscription-new-tank-with-basic-confirm-plan-button"
        >
          {{ $t('xContinue') }}
          <b-spinner class="ml-2" v-if="isCreatingPurchaseIntent" />
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SubscriptionCard from './Common/SubscriptionCard.vue'

export default {
  props: [
    'basicHsbList',
    'apparatusDetails',
    'selectedProduct',
    'monthlyPaidProduct',
    'annualPaidProduct',
    'isCreatingPurchaseIntent'
  ],
  emits: ['openPayment', 'setSelectedProduct'],
  components: {
    SubscriptionCard
  },
  methods: {
    setSelectedProduct(product) {
      this.$emit('setSelectedProduct', product)
    }
  }
}
</script>
<style lang="scss">
.current-plan {
  .plan-details-header {
    font-size: 16px;
    line-height: 24px;
    color: var(--carbon-900);
  }
}
</style>
